
import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message, Tag, Icon, Select } from 'antd';
import { Modal as AntdModal } from 'antd';
import { withTranslation } from 'react-i18next';
import { getRoleList, delRole, getResourceList, getPolicyList, postCreateRole, putRole } from '../../../axios';
import { Tree } from 'antd';
import { convertUTCDateToLocalDate } from '../../../utils'
import '../index.less'


const FormItem = Form.Item;

const RoleManage = (props) => {
	// Get all node keys (including category, menu, api)
	const getAllKeys = (tree) => {
		let keys = [];
		tree.forEach(node => {
			keys.push(node.key);
			if (node.children && node.children.length > 0) {
				keys = keys.concat(getAllKeys(node.children));
			}
		});
		return keys;
	};
	// Get all API or menu node keys
	const getAllKeysByType = (tree, type) => {
		let keys = [];
		tree.forEach(node => {
			if (node.type === type) {
				keys.push(node.key);
			}
			if (node.children && node.children.length > 0) {
				keys = keys.concat(getAllKeysByType(node.children, type));
			}
		});
		return keys;
	};
	// General recursive processing of categories/menus/apis under data
	const buildTreeData = (data) => {
		if (!data) return [];
		let nodes = [];
		// Handle categories
		if (Array.isArray(data.categories)) {
			nodes = nodes.concat(data.categories.map(cat => ({
				key: cat.id,
				title: cat.name,
				type: 'category',
				children: buildTreeData(cat.children)
			})));
		}
		// Handle menus
		if (Array.isArray(data.menus)) {
			nodes = nodes.concat(data.menus.map(menu => ({
				key: menu.id,
				title: <span>{menu.name} <Tag color="blue">{t('Menu')}</Tag></span>,
				type: 'menu',
				children: buildTreeData(menu.children)
			})));
		}
		// Handle apis
		if (Array.isArray(data.apis)) {
			nodes = nodes.concat(data.apis.map(api => ({
				key: api.id,
				title: <span>{api.name} <Tag color="green">{t('API')}</Tag></span>,
				type: 'api',
				children: buildTreeData(api.children)
			})));
		}
		return nodes;
	};
	const t = props.t;
	const [data, setData] = useState([]);
	const [modalVisible, setModalVisible] = useState(false);
	const [editing, setEditing] = useState(null);
	const [formValues, setFormValues] = useState({});
	const [formErrors, setFormErrors] = useState({});
	const [treeCheckedKeys, setTreeCheckedKeys] = useState([]);
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [keyword, setKeyword] = useState('');
	const [total, setTotal] = useState(0);
	const [treeData, setTreeData] = useState([]);
	const [strategyOptions, setStrategyOptions] = useState([]);

	useEffect(() => {
		fetchRoleList();
	}, [page, keyword]);

	useEffect(() => {
		// Get resource list
		handleGetResourceList();
		// Get policy list
		initPolicyList();
	}, []);

	const fetchRoleList = async () => {
		setLoading(true);
		const params = { page, per_page: pageSize, keyword: keyword };
		const res = await getRoleList(params);
		setLoading(false);
		if (res.code === 100000 && res.data && res.data.list) {
			setData(res.data.list);
			setTotal(res.data.pagination.total);
		}
	};

	const handleGetResourceList = async () => {
		const res = await getResourceList();
		if (res.code === 100000 && res.data) {
			const treeData = buildTreeData(res.data);
			setTreeData(treeData);
		} else {
			message.error(t('GetResourceListFailed'));
			return [];
		}
	};

	const handleDelRole = async (id) => {
		const res = await delRole(id);
		if (res.code === 100000) {
			message.success(t('DeleteSuccess'));
			fetchRoleList();
		} else {
			message.error(res.data.message || t('DeleteFailed'));
		}
	};

	const handlekeywordChange = (e) => {
		setKeyword(e.target.value);
		setPage(1);
	};

	const showModal = (record = null) => {
		setModalVisible(true);
		setEditing(record);
		setFormValues(record ? { ...record, strategy: record.policies } : {});
		if (record && record.resources) {
			setTreeCheckedKeys(record.resources);
		} else {
			setTreeCheckedKeys([]);
		}
	};

	const handleCancel = () => {
		setModalVisible(false);
		setEditing(null);
		setFormValues({});
	};

	const handleDelete = record => {
		AntdModal.confirm({
			title: t('ConfirmDelete'),
			content: t('DeleteTip'),
			okText: t('Yes'),
			cancelText: t('No'),
			onOk: () => {
				handleDelRole(record.id);
			}
		});
	};

	const handleFormChange = (e) => {
		const { name, value } = e.target;
		setFormValues(prev => ({ ...prev, [name]: value }));
	};

	const handleTreeCheck = (checkedKeys) => {
		setTreeCheckedKeys(checkedKeys);
		setFormValues(prev => ({ ...prev, resources: checkedKeys }));
	};

	const handleOk = () => {
		let errors = {};
		if (!formValues.name) {
			errors.name = t('PleaseEnterRolesName');
		}
		if (!formValues.description) {
			errors.description = t('PleaseEnterDescription');
		}
		if (!formValues.resources || formValues.resources.length === 0) {
			errors.resources = t('PleaseSelectPermissionResources');
		}
		setFormErrors(errors);
		if (Object.keys(errors).length > 0) return;
		if (editing) {
			const data = { name: formValues.name, description: formValues.description, policy_ids: formValues.strategy, resource_ids: formValues.resources };
			handleEditRole({ id: editing.id, data });
		} else {
			console.log('create role', formValues);
			const data = { name: formValues.name, description: formValues.description, policy_ids: formValues.strategy, resource_ids: formValues.resources };
			handleCreateRole(data);
		}
		setModalVisible(false);
		setEditing(null);
		setFormValues({});
		setFormErrors({});
		setTreeCheckedKeys([]);
	};

	const handleCreateRole = async (values) => {
		const res = await postCreateRole(values);
		if (res.code === 100000) {
			message.success(t('CreateSuccess'));
			fetchRoleList();
		} else {
			message.error(res.data.message || t('CreateFailed'));
		}
	};

	const handleEditRole = async (id, values) => {
		const res = await putRole(id, values);
		if (res.code === 100000) {
			message.success(t('EditSuccess'));
			fetchRoleList();
		} else {
			message.error(res.data.message || t('EditFailed'));
		}
	};

	const pageChange = (page, pageSize) => {
		setPage(page);
		setPageSize(pageSize);
		// fetchRoleList(keyword);
	};

	const initPolicyList = async () => {
		const res = await getPolicyList();
		if (res.code === 100000 && res.data) {
			const policies = res.data || [];
			const options = policies.map(policy => ({
				value: policy.id,
				label: `${policy.name}(${policy.description})`,
			}));
			console.log('policies', policies, options);
			setStrategyOptions(options);
		} else {
			message.error(t('GetPolicyListFailed'));
		}
	};

	const columns = [
		{ title: t('Name'), dataIndex: 'name', key: 'name' },
		{
			title: t('CreateTime'),
			dataIndex: 'create_time',
			key: 'create_time',
			render: (text) => convertUTCDateToLocalDate(text)
		},
		{
			title: t('Description'),
			dataIndex: 'description',
			key: 'description',
		},
		{
			title: t('Action'),
			key: 'action',
			render: (text, record) => {
				const hidden = record.name === 'Super Admin' || record.name === 'NSD104 Covered'
				return (<span className='action-btns' hidden={hidden}>
					{record.id !== 1 && <Button type="link" onClick={() => { showModal(record) }} >{t('Edit')}</Button>}
					{record.id !== 1 && <Button type="link" onClick={() => { handleDelete(record) }}>{t('Delete')}</Button>}
				</span>)
			},
		},
	];

	return (
		<div className='main-new'>
			<div className="main-cotent">
				<div className='permissionManagement'>
					<div className='topBox'>
						<Input
							style={{ width: '300px' }}
							className='inputEllipsis'
							placeholder={t('Name')}
							prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
							onPressEnter={handlekeywordChange}
							onChange={handlekeywordChange}
							allowClear
						/>
						<Button type="primary" onClick={() => showModal()}>{t('AddRole')}</Button>
					</div>
					<Table
						rowKey={record => record.id}
						columns={columns}
						dataSource={data}
						loading={loading}
						pagination={{ current: page, pageSize: pageSize, total: total, onChange: pageChange }}
						locale={{
							emptyText:
								<div className='empty-table'>
									<p> {t('NoData')}</p>
								</div>
						}} />
					<Modal
						title={editing ? 'Edit' : 'Add'}
						width={720}
						visible={modalVisible}
						onOk={handleOk}
						onCancel={handleCancel}
					>
						<Form layout="vertical">
							<div style={{ display: 'flex', gap: 16 }}>
								<FormItem
									label={t('RolesName')}
									required
									validateStatus={formErrors.name ? 'error' : ''}
									help={formErrors.name}
									style={{ flex: 1 }}
								>
									<Input name="name" value={formValues.name || ''} onChange={handleFormChange} placeholder={t('PleaseEnterRolesName')} />
								</FormItem>
								<FormItem
									label={t('Description')}
									required
									validateStatus={formErrors.description ? 'error' : ''}
									help={formErrors.description}
									style={{ flex: 1 }}
								>
									<Input name="description" value={formValues.description || ''} onChange={handleFormChange} placeholder={t('PleaseEnterDescription')} />
								</FormItem>
							</div>
							<FormItem
								label={t('Strategy')}
								required={false}
								validateStatus={formErrors.strategy ? 'error' : ''}
								help={formErrors.strategy}
							>
								<Select
									mode="multiple"
									style={{ width: '100%' }}
									placeholder={t('SelectStrategy')}
									value={formValues.strategy || []}
									onChange={vals => handleFormChange({ target: { name: 'strategy', value: vals } })}
								>
									{strategyOptions.map(opt => (
										<Select.Option key={opt.value} value={opt.value}>
											{opt.label}
										</Select.Option>
									))}
								</Select>
							</FormItem>
							<FormItem
								label={t('PermissionResources')}
								required
								validateStatus={formErrors.resources ? 'error' : ''}
								help={formErrors.resources}
							>
								<div style={{ marginBottom: 8 }}>
									<Button size="small" style={{ marginRight: 8 }} onClick={() => {
										const allApiKeys = getAllKeysByType(treeData, 'api');
										setTreeCheckedKeys(allApiKeys);
										setFormValues(prev => ({ ...prev, resources: allApiKeys }));
									}}>{t('SelectAllAPIs')}</Button>
									<Button size="small" style={{ marginRight: 8 }} onClick={() => {
										const allMenuKeys = getAllKeysByType(treeData, 'menu');
										setTreeCheckedKeys(allMenuKeys);
										setFormValues(prev => ({ ...prev, resources: allMenuKeys }));
									}}>{t('SelectAllMenus')}</Button>
									<Button size="small" style={{ marginRight: 8 }} onClick={() => {
										const allKeys = getAllKeys(treeData);
										setTreeCheckedKeys(allKeys);
										setFormValues(prev => ({ ...prev, resources: allKeys }));
									}}>{t('SelectAll')}</Button>
									<Button size="small" onClick={() => {
										setTreeCheckedKeys([]);
										setFormValues(prev => ({ ...prev, resources: [] }));
									}}>{t('ClearAll')}</Button>
								</div>
								<Tree
									checkable
									treeData={treeData}
									checkedKeys={treeCheckedKeys}
									onCheck={handleTreeCheck}
									selectable={false}
									style={{ maxHeight: 300, overflow: 'auto', border: '1px solid #eee', padding: 8 }}
								/>
							</FormItem>
						</Form>
					</Modal>
				</div>
			</div>
		</div>
	);
}

export default withTranslation(['common'])(RoleManage);
